import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
interface INotificationProps {
  active?: boolean;
  label: string;
}

const Notification = ({ active = true, label }: INotificationProps) => {
  return (
    <div className={styles.notification}>
      <span 
        className={classNames(styles.notificationStatus, active && styles.active)} 
        data-testid="notification-status" 
      />
      <span className="notification__text" data-testid="notification-text">{label}</span>
    </div>
  );
};

export default Notification;